<script>
    import FaIcon from 'fa-svelte';
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
    import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
    import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';

    // the Review object
    export let model;

    export let showLabel = false;

    export let style;

    $: isAccepted = model.acceptanceStatus == "ACCEPTED";
    $: isRejected = model.acceptanceStatus == "REJECTED";
    $: isPending = !isAccepted && !isRejected && model.acceptanceStatus != "NONE";

    const iconTable = {
        "ACCEPTED": faCheckCircle,
        "REJECTED": faTimesCircle,
        "ACCEPTANCE_PENDING": faClock,
        "NONE": faTimesCircle
    };

    $: icon = iconTable[model.acceptanceStatus];
    $: stateName = model.acceptanceStatus.toLowerCase();
    $: label = model.acceptanceStatus.replace("ACCEPTANCE_", "").toLowerCase();

    console.log("[ReviewStatusSymbol] init with model:");
    console.log(model);
    //console.log(stateName);

</script>

<span class="review-status-symbol {stateName}" {style}>
    <FaIcon {icon}/>

    {#if showLabel}
        <span class="review-status-name">{label}</span>
    {/if}
</span>

<style>
    :global(.review-status-symbol) {
        display: inline-block;
    }

    :global(.review-status-symbol.acceptance_pending .fa-svelte) {
        color: #DDD;
    }

    :global(.review-status-symbol.rejected .fa-svelte) {
        color: #C00;
    }

    :global(.review-status-symbol.accepted .fa-svelte) {
        color: green;
    }
</style>

